import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { styled } from "@mui/material/styles";
import { grey } from "designSystem/styles/color";
import { ComponentItem } from "designSystem/types/component-item-types";
import Button from "designSystem/components/button/Button";
import Menu from "designSystem/components/menu/Menu";
import MenuItem from "designSystem/components/menu/MenuItem";
import OverflowText from "designSystem/components/text/OverflowText";
import React, { FunctionComponent, PropsWithChildren, useState } from "react";
import { useLocale } from "designSystem/locale";

const PREFIX = "ChipSelect";

const classes = {
	root: `${PREFIX}root`,
};

const Root = styled("div")(({
	theme,
}) => ({
	[`& .${classes.root}`]: {
		background: grey[200],
		border: `1px solid ${grey[400]}`,
		borderRadius: 30,
		height: 22,
	},
}));

interface ChipSelectProps extends PropsWithChildren {

	/** custom styles */
	className?: string;

	/** flag to indicate disabled state */
	disabled?: boolean;

	/** the store of the menu */
	items?: ComponentItem[];

	/** extension point when item is selected */
	onSelectItem?: (item: ComponentItem) => void;

	/** localization resource for button */
	buttonRes?: string;

	/** localization resource parameters for button */
	buttonResParams?: Array<number | string>;

	/** label for chip */
	buttonText?: string;
}

const ChipSelect: FunctionComponent<ChipSelectProps> = (props) => {
	const {
		className,
		disabled = false,
		buttonRes,
		buttonResParams,
		buttonText,
		children,
		items,
		onSelectItem,
	} = props;



	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const onClickButton = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const onCloseMenu = () => {
		setAnchorEl(null);
	};

	const loc = useLocale();

	const value = buttonRes ? loc.resource(buttonRes, buttonResParams) : buttonText;

	return (
		(
			<Root>
				<Button
					className={`${classes.root} ${className || ""}`}
					design="outline"
					disabled={disabled}
					endIcon={<ArrowDropDown />}
					onClick={onClickButton}
				>
					<OverflowText
						bold
						text={value}
					/>
				</Button>
				<Menu
					align="left"
					anchorEl={anchorEl}
					onClose={onCloseMenu}
					open={Boolean(anchorEl)}
				>
					{children ||
					items.map((item) => (
						<MenuItem
							key={item.id}
							onClick={() => onSelectItem?.(item)}
							text={loc.getComponentItemName(item)}
						/>
					))
					}
				</Menu>
			</Root>
		)
	);
};

export default ChipSelect;